// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "styles" + "." + "8e1ee91910bc8e944466" + ".css";
};